import { Alert } from "antd";
import React from "react";
import { useSelector } from "react-redux";

export const DatosEsNoProcedente = () => {
  const { motivoNoProcedente } = useSelector(
    (state) => state.asistenciasReducer.asistencia
  );

  return <Alert type="warning" message={"no procede: "+motivoNoProcedente} />;
};
